import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../../src/app/pages/auth/login/login.component';
import { NavComponent } from '../../src/app/pages/nav/nav.component';
import { LoginGuardService } from '../../src/app/_helpers/login-guard.service';
import { HomeComponent } from './pages/home/home.component';
import { ErrorpageComponent } from './pages/errorpage/errorpage.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent },
  {
    path: '',
    component: NavComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'plantview',
        loadChildren: () =>
          import('./modules/plant-view/plant-view.module').then(
            (m) => m.PlantViewModule
          ),
      },
      {
        path: 'breakup',
        loadChildren: () =>
          import('./modules/breakup/breakup.module').then(
            (m) => m.BreakupModule
          ),
      },
      {
        path: 'trends',
        loadChildren: () =>
          import('./modules/trends/trends.module').then((m) => m.TrendsModule),
      },
      {
        path: 'kpi',
        loadChildren: () =>
          import('./modules/kpi/kpi.module').then((m) => m.KpiModule),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./modules/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
      },
      {
        path: 'comparison',
        loadChildren: () =>
          import('./modules/comparison/comparison.module').then(
            (m) => m.ComparisonModule
          ),
      },
      {
        path: 'lossanalytics',
        loadChildren: () =>
          import('./modules/lossanalytics/lossanalytics.module').then(
            (m) => m.LossanalyticsModule
          ),
      },
      {
        path: 'dadq',
        loadChildren: () =>
          import('./modules/dadq/dadq.module').then((m) => m.DadqModule),
      },
      {
        path: 'ipmvp',
        loadChildren: () =>
          import('./modules/ipmvp/ipmvp.module').then((m) => m.IpmvpModule),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./modules/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'assetview',
        loadChildren: () =>
          import('./modules/assetview/assetview.module').then((m) => m.AssetviewModule),
      },
      {
        path: 'alerts',
        loadChildren: () =>
          import('./modules/alerts/alerts.module').then((m) => m.AlertsModule),
      },
      {
        path: 'meterhierarchy',
        loadChildren: () =>
          import('./modules/meterhierarchy/meterhierarchy.module').then((m) => m.MeterHierachyModule),
      }
    ],
    canActivate: [LoginGuardService]
  },
  { path: '**', component: ErrorpageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
